import * as types from "../types/single-contact-list";
import { call, put, takeEvery, all } from "redux-saga/effects";
import {
  retrieveContactListDetails,
  retrieveContactListRecords,
  addSingleContactListRecord,
  updateSingleContactListRecord,
  fetchSingleRecord,
  deleteMultipleContactsArray,
  deleteContact,
  addCsvRecord,
} from "../../networking/single-contact-list/networking";

function* fetchSingleContactListDetails(action) {
  try {
    const details = yield call(retrieveContactListDetails, action.payload);
    if (details.error === null && details.payload) {
      yield put({
        type: types.SET_SINGLE_CONTACT_LIST_DETAILS,
        details: details.payload,
      });
    } else {
      throw new Error("Kunne ikke hente detaljer.");
    }
  } catch (e) {
    yield put({
      type: types.REVOKE_SINGLE_CONTACT_LIST_DETAILS,
      message: "Kunne ikke hente detaljer.",
    });
  }
}

function* fetchSingleContactListRecords(action) {
  try {
    const details = yield call(retrieveContactListRecords, action.payload);
    if (details.error === null && details.payload) {
      yield put({
        type: types.SET_SINGLE_CONTACT_LIST_RECORDS,
        details: details.payload,
      });
    } else {
      throw new Error("Kunne ikke hente detaljer.");
    }
  } catch (e) {
    yield put({
      type: types.REVOKE_SINGLE_CONTACT_LIST_RECORDS,
      message: "Kunne ikke hente liste.",
    });
  }
}

function* performAddSingleRecord(action) {
  try {
    if (action.payload) {
      var response = yield call(addSingleContactListRecord, action.payload);
      if (response.error === null) {
        yield put({ type: types.GRANT_ADD_SINGLE_CONTACT_LIST_RECORD });
        yield put({
          type: types.CHANGE_SINGLE_CONTACT_LIST_MODAL,
          modal: { addSingleModal: false },
        });
      } else {
        throw new Error("Kunne ikke legge til kontakt.");
      }
    } else {
      throw new Error("Kunne ikke legge til kontakt.");
    }
  } catch (e) {
    yield put({
      type: types.REVOKE_ADD_SINGLE_CONTACT_LIST_RECORD,
      message: e,
    });
    yield put({
      type: types.CHANGE_SINGLE_CONTACT_LIST_MODAL,
      modal: { addSingleModal: false },
    });
  }
}

function* fetchContactSelection(action) {
  try {
    if (action.payload) {
      var response = yield call(fetchSingleRecord, action.payload);
      if (response.error === null && response.payload) {
        yield put({
          type: types.SET_VIEW_CONTACT_SELECTION,
          details: response.payload,
        });
      }
    } else {
      throw new Error("Kunne ikke hente kontaktinformasjon.");
    }
  } catch (e) {
    yield put({
      type: types.REVOKE_VIEW_CONTACT_SELECTION,
      message: "Kunne ikke hente detaljer.",
    });
  }
}

function* updateContactSelection(action) {
  try {
    if (action.payload) {
      var response = yield call(updateSingleContactListRecord, action.payload);
      if (response.error === null && response.payload) {
        yield put({
          type: types.GRANT_UPDATE_CONTACT_SELECTION,
          details: response.payload,
        });
        yield put({
          type: types.CHANGE_SINGLE_CONTACT_LIST_MODAL,
          modal: { editSingleModal: false },
        });
      } else {
        throw new Error("Kunne ikke oppdatere detaljer.");
      }
    } else {
      throw new Error("Kunne ikke oppdatere detaljer.");
    }
  } catch (e) {
    yield put({
      type: types.REVOKE_UPDATE_CONTACT_SELECTION,
      message: "Kunne ikke oppdatere detaljer.",
    });
    yield put({
      type: types.CHANGE_SINGLE_CONTACT_LIST_MODAL,
      modal: { editSingleModal: false },
    });
  }
}

function* performRemoveContactsArray(action) {
  try {
    if (action.details) {
      const response = yield call(deleteMultipleContactsArray, action.details);
      if (response.error === null && response.payload) {
        yield put({
          type: types.GRANT_DELETE_SINGLE_CONTACT_LIST_ARRAY,
          details: response.payload,
        });
      } else {
        throw new Error("Kunne ikke slette kontakter.");
      }
    } else {
      throw new Error("Kunne ikke slette kontakter.");
    }
  } catch (e) {
    yield put({
      type: types.REVOKE_DELETE_SINGLE_CONTACT_LIST_ARRAY,
      message: e,
    });
  }
}

function* performRemoveSingleContact(action) {
  try {
    if (action.details) {
      var response = yield call(deleteContact, action.details);
      if (response.error === null && response.payload !== null) {
        yield put({
          type: types.GRANT_DELETE_SINGLE_CONTACT,
          details: response.payload,
        });
        yield put({
          type: types.CHANGE_SINGLE_CONTACT_LIST_MODAL,
          modal: { deleteSingleModal: false },
        });
      } else {
        throw new Error("Kunne ikke fjerne kontakt.");
      }
    } else {
      throw new Error("Kunne ikke slette kontakt.");
    }
  } catch ({ error }) {
    yield put({ type: types.REVOKE_DELETE_SINGLE_CONTACT, message: error });
    yield put({
      type: types.CHANGE_SINGLE_CONTACT_LIST_MODAL,
      modal: { deleteSingleModal: false },
    });
  }
}

function* performAddCsvFile(action) {
  try {
    if (action.payload) {
      var response = yield call(addCsvRecord, action.payload);
      if (response.error === null) {
        yield put({ type: types.GRANT_UPLOAD_SINGLE_CSV_FILE });
        yield put({
          type: types.CHANGE_SINGLE_CONTACT_LIST_MODAL,
          modal: { addCsvModal: false },
        });
      } else {
        throw new Error("Kunne ikke legge til kontakt.");
      }
    } else {
      throw new Error("Kunne ikke legge til kontakt.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_UPLOAD_SINGLE_CSV_FILE, message: e });
    yield put({
      type: types.CHANGE_SINGLE_CONTACT_LIST_MODAL,
      modal: { addCsvModal: false },
    });
  }
}

function* singleContactListSaga() {
  yield all([
    takeEvery(
      types.REQUEST_SINGLE_CONTACT_LIST_DETAILS,
      fetchSingleContactListDetails
    ),
    takeEvery(
      types.REQUEST_SINGLE_CONTACT_LIST_RECORDS,
      fetchSingleContactListRecords
    ),
    takeEvery(
      types.REQUEST_ADD_SINGLE_CONTACT_LIST_RECORD,
      performAddSingleRecord
    ),
    takeEvery(types.REQUEST_VIEW_CONTACT_SELECTION, fetchContactSelection),
    takeEvery(types.REQUEST_UPDATE_CONTACT_SELECTION, updateContactSelection),
    takeEvery(
      types.REQUEST_DELETE_SINGLE_CONTACT_LIST_ARRAY,
      performRemoveContactsArray
    ),
    takeEvery(types.REQUEST_DELETE_SINGLE_CONTACT, performRemoveSingleContact),
    takeEvery(types.REQUEST_UPLOAD_SINGLE_CSV_FILE, performAddCsvFile),
  ]);
}

export default singleContactListSaga;
